module.exports = __webpack_public_path__ + "static/media/wave-policie-blue.5a200b0e.svg";